import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SearchOverlayService } from '../../../services/search-overlay.service';
import { SearchBoxComponent } from '@immosky/shared';
import { AppState } from '@immosky/types';
import { Store } from '@ngrx/store';
import { LayoutService } from '../../../services/layout.service';

@Component({
  selector: 'app-search-overlay',
  templateUrl: './search-overlay.component.html',
  styleUrls: ['./search-overlay.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchOverlayComponent {
  isOpen = false;

  @ViewChild('searchBox')
  searchBox!: SearchBoxComponent;

  constructor(
    private store: Store<AppState>,
    private searchOverlayService: SearchOverlayService,
    private cdRef: ChangeDetectorRef,
    private layoutService: LayoutService
  ) {
    this.searchOverlayService.isOpen.subscribe((isOpen: boolean) => {
      this.isOpen = isOpen;

      if (this.isOpen) {
        setTimeout(() => {
          this.searchBox?.focusInput();
        }, 0);
      } else {
        this.searchBox?.clearInput();
      }

      this.cdRef.markForCheck();
    });
  }

  openMobileFilters() {
    this.layoutService.openMobileFilters();
    this.close();
  }

  close() {
    this.searchOverlayService.close();
  }
}
